import { Icons } from '@common';
import type { ReactElement } from 'react';

interface LoadingProps {
  color: string;
}

export function Loading(props: LoadingProps): ReactElement {
  const { color } = props;

  return <Icons name='LoadingIcon' style={{ color }} />;
}
